module.exports = __webpack_public_path__ + "img/Arrow.5c3bbb7a.svg";